import { Card, FormField, FormRow } from "@endya-conformite/ui-kit";
import classNames from "classnames";
import { ResumeBlockComponentProps } from "./RenouvellementResumeEntreprisePage";
import styles from "./resumeContactMediation.module.scss";

type ResumeContactMediationProps = ResumeBlockComponentProps & {
  isValid: boolean;
};

export function ResumeContactMediation({
  data,
  isValid,
}: ResumeContactMediationProps) {
  return (
    <Card
      variant="accent"
      className={classNames({ [styles.errorCard]: !isValid })}
    >
      <FormRow>
        <FormField>
          Civilité : <b>{data.resume.contactMediation.civiliteMediation}</b>
        </FormField>
        <FormField>
          Nom : <b>{data.resume.contactMediation.nomMediation}</b>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          Prénom : <b>{data.resume.contactMediation.prenomMediation}</b>
        </FormField>
        <FormField>
          Téléphone : <b>{data.resume.contactMediation.telephoneMediation}</b>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          Email : <b>{data.resume.contactMediation.mailMediation}</b>
        </FormField>
      </FormRow>
    </Card>
  );
}
